<template>
  <img
    data-cy="cmp-logo"
    src="../assets/logo.svg"
    :draggable="false"
  >
</template>

<script>
export default {
};
</script>
